import { defineComponent, h } from 'vue';

const CAlertHeading = defineComponent({
    name: 'CAlertHeading',
    props: {
        /**
         * 	Component used for the root node. Either a string to use a HTML element or a component.
         */
        as: {
            type: String,
            default: 'h4',
        },
    },
    setup(props, { slots }) {
        return () => h(props.as, {
            class: 'alert-heading',
        }, slots);
    },
});

export { CAlertHeading };
//# sourceMappingURL=CAlertHeading.js.map
